<template>
    <div class="agreement_box no-trans" v-loading="loading">
        <el-dialog :title="titles" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
            <div class="dialog_box">
                <div class="titles1">{{titles}}</div>
                <div class="consts" v-html="consts">
                    欢迎访问平台并使用我们提供的产品和服务。 <br>
                    在完成注册程序或以任何方式使用顶律平台服务前，请您务必仔细阅读并透彻理解本顶律平台服务条款(以下或简称“服务条款”)，在确认充分理解后选择接受或不接受本服务条款；一旦您完成“同意条款并注册”或开始以其他方式使用顶律服务，即表明您已阅读并同意受本服务条款的约束。如您不同意本服务条款或其中任何条款约定，您应不再进行下一步或停止注册程序。 <br>
                    顶律再次提示您审慎阅读、充分理解各条款内容，特别是限制或免除责任的相应条款，限制或免除责任条款将以加粗或其他醒目形式提示您注意。 <br>
                    如果您未满18周岁，请在法定监护人的陪同下阅读本服务条款。 <br>
                    <br>
                    一、 签约主体以及协议范围 <br>
                    1.1. 顶律平台服务条款是您与成都顶泰法律咨询科技有限公司（“顶律”或者“我们”）就使用顶律平台服务（包含为您提供网站页面信息浏览、账户注册服务等）而订立的有效合约。 <br>
                    顶律平台包含域名为https://dlaw.dgg.cn/的网站以及顶律微信小程序。 <br>
                    1.2. 如您使用或购买顶律平台上某一具体服务，您可仍需确认具体服务对应的服务条款；请您审慎阅读、充分理解各条款内容，选择接受或不接受该服务条款。 <br>

                    二、账户的注册、使用与安全 <br>
                    2.1. 注册的资格 <br>
                    2.1.1. 您确认，在您完成注册程序或以其他顶律允许的方式实际使用本服务时，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织（以下或简称为“您”）。 <br>
                    2.1.2. 若您是未成年人或限制民事行为能力人，则您不具备前述主体资格，您及您的监护人应承担因您的不当注册行为而导致的一切后果。 <br>
                    2.1.3. 您还需确保您不是任何国家、国际组织或者地域实施的贸易限制、制裁或其他法律、规则限制的对象，否则您可能无法正常注册及使用顶律服务。 <br>
                </div>
               
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading:false,
            dialogVisible:true,//显示隐藏
            titles:'《中华人民共和国国务院令》',
            consts:'',//内容
            
           
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {
        this.get_setting()
    },
    methods: {
        handleClose(){
            this.dialogVisible=false
        },
        handle_end(){
            this.dialogVisible=false
            this.$emit('handle_end')
        },
        handle_open(){
            this.dialogVisible=true
        },
        get_setting(){
            this.$api("setting", {
			 
			}, "get").then((res) => {
                 this.consts=res.data.country_notice
               
            });
        },




    },

}
</script>
<style scoped lang="less">
.agreement_box {
    /deep/.el-dialog__wrapper{
        .el-dialog{
            width: 960px;
            .el-dialog__header{
                background: #F7F7F7;
            }
            .el-dialog__body{
                .dialog_box{
                    .titles1{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;
                        text-align: center;
                    }
                    .titles2{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        text-align: center;
                        padding-top: 31px;
                    }
                    .consts{
                        padding-top: 24px;
                        height: 500px;
                        overflow-y: scroll;
                        padding: 0 30px;
                        line-height: 25px;
                    }
                    .btn_flex{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .bnts{
                            width: 280px;
                            height: 40px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            line-height: 40px;
                            text-align: center;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #FFFFFF;

                        }
                    }
                }
            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .agreement_box.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .titles1 {
        font-size: 18px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .titles2 {
        font-size: 14px;
        padding-top: 16px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .consts {
        padding-top: 16px;
        min-height: 0;
        height: auto;
        padding: 0 16px;
        line-height: 25px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btn_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btn_flex .bnts {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 40px;
        border-radius: 4px 4px 4px 4px;
        line-height: 40px;
        font-size: 14px;
    }
}
</style>
